"use client";

import { formatCurrency } from "@/lib/utils/formatter";
import { useEmployeeInfo } from "@/modules/hooks/employee/useEmployeeInfo";
import { MoneyUnit } from "@/modules/types/enum";

interface JobSalaryDisplayProps {
  requiredLogin: boolean;
  isNegotiable: boolean;
  minSalary: number;
  maxSalary: number;
  moneyUnit: MoneyUnit;
  loginToViewSalary: string;
  salaryNegotiable: string;
}

export const JobSalaryDisplay = ({
  requiredLogin,
  isNegotiable,
  minSalary,
  maxSalary,
  moneyUnit,
  loginToViewSalary,
  salaryNegotiable,
}: JobSalaryDisplayProps) => {
  const { employeeInfo } = useEmployeeInfo();

  return (
    <>
      {requiredLogin && !employeeInfo ? (
        <span>{loginToViewSalary}</span>
      ) : isNegotiable ? (
        salaryNegotiable
      ) : minSalary <= 0 ? (
        `Up to ${formatCurrency(maxSalary, moneyUnit)}`
      ) : (
        `${formatCurrency(minSalary, moneyUnit)} - ${formatCurrency(
          maxSalary,
          moneyUnit,
        )}`
      )}
    </>
  );
};
